export const apiTransformer = (values, keysToTransform = [])=> {
    return Object.keys(values).reduce(function (changedValues, key) {
        if (keysToTransform.includes(key)) {
            changedValues[key] = values[key] === null ? null : '/api/' + endpointMiddleName(key) + '/' + values[key];
        } else {
            changedValues[key] = values[key];
        }
        return changedValues;
    }, {});
}

const endpointMiddleName = key => {
    switch (key) {
    case 'secondTrainer':
        return 'trainers';
    // A club's head club is a CLUB — the naive key + 's' would build
    // /api/parentClubs and 404.
    case 'parentClub':
        return 'clubs';
    case 'secretary':
        return 'secretaries';
    case 'fee':
        return 'competition_fees';
    case 'secondReferee':
        return 'referees';
    default:
        return key + 's';
    }
}
